export enum SiteType {
  CUSTOMER_SITE = 'customer_site',
  PRODUCTION_SITE = 'production_site',
  STOCK = 'stock',
  MOBILE_FLEET = 'mobile_fleet'
}
